export default "__VITE_ASSET__DVQP7G7M__"